import { BraintreePayPalButtons } from "@paypal/react-paypal-js"
import { Fragment } from "react"

import { PaymentErrorMessage } from "../payment-error/payment-error-message"

import { usePaypal } from "./use-paypal"

export const PaypalButton = ({ type, order, intent }) => {
  const {
    error,
    handleCreateBillingAgreement,
    handleCreateOrder,
    handleApprove,
    handleCancel,
    handleError,
  } = usePaypal({
    paymentMethodType: type,
    order,
  })

  return (
    <Fragment>
      <BraintreePayPalButtons
        fundingSource="paypal"
        onError={handleError}
        {...(intent === "tokenize"
          ? {
              createBillingAgreement: handleCreateBillingAgreement,
            }
          : { createOrder: handleCreateOrder })}
        onApprove={handleApprove}
        onCancel={handleCancel}
      />

      <PaymentErrorMessage paymentError={error} />
    </Fragment>
  )
}
